import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { trackEvent } from "@/lib/analytics";
import { Heart, Loader2, AlertCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking"); // checking | error | timeout
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }

    let timer;
    const poll = async () => {
      attempts.current += 1;
      if (attempts.current > 15) { setStatus("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          const cid = data.conversation_id || localStorage.getItem("rawlove_pending_cid");
          trackEvent("payment_success", cid);
          localStorage.removeItem("rawlove_pending_cid");
          if (localStorage.getItem("rawlove_conversation_id") === cid) localStorage.removeItem("rawlove_conversation_id");
          navigate(`/result/${cid}`, { replace: true });
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch {
        /* keep polling */
      }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-[#FAF7F2] px-5">
      <div className="text-center max-w-md" data-testid="payment-success-page">
        <div className="w-16 h-16 rounded-full bg-[#F4E3E2] flex items-center justify-center mx-auto mb-6">
          <Heart className="w-8 h-8 text-[#6E2D38] fill-[#6E2D38]" />
        </div>
        {status === "checking" && (
          <>
            <h1 className="font-editorial text-3xl font-medium mb-3">Merci pour ta confiance</h1>
            <p className="text-[#5C4A45] flex items-center justify-center gap-2">
              <Loader2 className="w-4 h-4 animate-spin" />
              Maryline prépare ton analyse…
            </p>
          </>
        )}
        {(status === "error" || status === "timeout") && (
          <>
            <div className="w-12 h-12 rounded-full bg-[#FDF0F0] flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="w-6 h-6 text-[#A83A3A]" />
            </div>
            <h1 className="font-editorial text-2xl font-medium mb-3">
              {status === "timeout" ? "Confirmation un peu longue" : "Paiement non confirmé"}
            </h1>
            <p className="text-[#5C4A45] mb-6">
              {status === "timeout"
                ? "Ton paiement peut mettre quelques instants à se confirmer. Réessaie dans un moment."
                : "Nous n'avons pas pu confirmer ton paiement."}
            </p>
            <button onClick={() => navigate("/chat?new=1")}
              className="bg-[#6E2D38] hover:bg-[#54212A] text-white rounded-full px-6 py-3 font-medium">
              Retour à Maryline
            </button>
          </>
        )}
      </div>
    </div>
  );
}
